import { render, staticRenderFns } from "./ClienteList.vue?vue&type=template&id=63a87786&scoped=true&"
import script from "./ClienteList.vue?vue&type=script&lang=js&"
export * from "./ClienteList.vue?vue&type=script&lang=js&"
import style0 from "./ClienteList.vue?vue&type=style&index=0&id=63a87786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a87786",
  null
  
)

export default component.exports